const IsEmptyObject = (value) => {
  if (typeof value === 'object') {
    for (var key in value) {
      if (value.hasOwnProperty(key))
        return false;
    }
    return true;
  }
};

/**
 * Retruns true for all valid values and false
 */
const IsFalseOrValue = (value) => {
  return value ? true : value === false;
};

/**
 * Retruns true for zero value and all valid values
 */
const IsZeroOrValue = (value) => {
  return value ? true : value === 0;
};

/**
 * Retruns true for all valid values and empty strings
 */
const IsEmptyStringOrValue = (value) => {
  return value ? true : value === '';
};

/**
 * Retruns false if values is falsy values Nan, null, undefined as well as empty objets and arrays. 
 * Return true for 0, empty string, and false. 
 */
export const HasValue = (value) => {
  //Check for values we still want to keep (0, empty, and false) and gaurd against empty objects and arrays)
  if (value || IsZeroOrValue(value) || IsEmptyStringOrValue(value) || IsFalseOrValue(value)) {
    if ((value.toString().trim().length !== 0 && typeof value !== 'object') || value === '' || (!IsEmptyObject(value) && typeof value === 'object')) {
      return true;
    }
  }
  return false;
};

/**
 * Returns true for all true values as well has 0, '', and false.
 * This incluedes empty object and arrays. 
 * Otherwise returns false. 
 */
export const HasTrueValue = (value) => {
  if (value || IsZeroOrValue(value) || IsEmptyStringOrValue(value) || IsFalseOrValue(value)) {
    return true;
  }
  return false;
};

/**
 * 
 * Returns true for all falsy values and empty objects/arrays
 */
export const IsEmpty = (value) => {
  if (!value && !IsZeroOrValue(value) && !IsFalseOrValue(value)) {
    return true;
  } else {
    if (value.toString().trim().length === 0 || IsEmptyObject(value)) {
      return true;
    }
  }
  return false;
};


// WEBPACK FOOTER //
// ./src/utils/ValidationUtils.js